export default "__VITE_ASSET__SH3JcDOvWNcn2WIvxBnLpg__";